import spartacusOnboardingAPI from '@api/jooicez-backend/spartacus/onboarding';
import { useAuth } from '@AuthProvider';
import OnboardingSpartacusV2Stepper from '@pages/onboarding-spartacus-v2/components/OnboardingSpartacusV2Stepper';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import paths from '../paths';

export default function OnboardingSpartacusV2Routes() {
  const { isLoading, user, setJooiceFlow } = useAuth();
  const navigate = useNavigate();
  const forceOnboardingV2 =
    localStorage.getItem('forceOnboardingV2') === 'true' ||
    localStorage.getItem('forceOnboarding') === 'true' ||
    new URLSearchParams(window.location.search).has('forceOnboardingV2');

  const handleCompleteOnboarding = () => {
    spartacusOnboardingAPI.tagUser();
    setJooiceFlow('SOCIAL');
    navigate(paths.spartacus.suggestions);
  };

  if (isLoading) return null;
  if (!forceOnboardingV2 && (user?.Account?.JooiceFlow === 'REVIEW' || user?.Account?.JooiceFlow === 'SOCIAL')) {
    return <Navigate to={paths.spartacus.suggestions} replace />;
  }

  return (
    <Routes>
      <Route index element={<OnboardingSpartacusV2Stepper handleCompleteOnboarding={handleCompleteOnboarding} />} />
    </Routes>
  );
}
